module.exports = __webpack_public_path__ + "static/media/DSC_0314.e25572b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0314.jpg
// module id = 574
// module chunks = 0